import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import Icon from "Components/Icon/Icon";
import TermsAcceptModal from "../TermsBanner/TermsAcceptModal";
import styles from "../TermsBanner/TermsBanner.module.scss";

/**
 * "Función aún no disponible" — modal que aparece al intentar usar una feature
 * bloqueada por no haber aceptado los T&C (nodo Figma 3408-90). "Ver términos"
 * abre el modal de aceptación (TermsAcceptModal). El bloqueo real es front por
 * ahora; este modal es el aviso.
 */
export default function TermsLockModal({ show, onClose }) {
  const { t } = useTranslation();
  const [showTerms, setShowTerms] = useState(false);

  const verTerminos = () => {
    onClose();
    setShowTerms(true);
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered contentClassName={styles.modalContent}>
        <Modal.Header closeButton>
          <div className="d-flex align-items-center gap-2">
            <Icon name="warning" size={24} style={{ color: "#c0601e" }} />
            <Modal.Title as="h5" className={styles.title}>
              {t("terms_lock_title", "Función aún no disponible")}
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          {t(
            "terms_lock_message",
            "Para usar esta herramienta es necesario aceptar los nuevos términos y condiciones. Toma menos de un minuto."
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex gap-2 w-100">
            <button type="button" className={`flex-fill ${styles.secondaryBtn}`} onClick={onClose}>
              {t("terms_lock_later", "Ahora no")}
            </button>
            <button type="button" className={`flex-fill ${styles.primaryBtn}`} onClick={verTerminos}>
              {t("terms_lock_view", "Ver términos")}
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <TermsAcceptModal show={showTerms} onHide={() => setShowTerms(false)} />
    </>
  );
}
